import Chat from "../Firestore/Chat.js";
import { NOTIFICATION_RETENTION_DAYS } from "../util/notificationTypes.js";

function timeOf(notification) {
  return notification.timestamp instanceof Date ? notification.timestamp.getTime() : NaN;
}

export default {
  computed: {
    chatContacts() {
      return this.contacts.filter(c => c.type !== "system");
    },
    visibleNotifications() {
      const cutoff = Date.now() - NOTIFICATION_RETENTION_DAYS * 24 * 60 * 60 * 1000;
      return this.systemNotifications
        .filter(n => {
          if (!n.unread) return false;
          const t = timeOf(n);
          return isNaN(t) ? true : t > cutoff;
        })
        .sort((a, b) => (timeOf(b) || 0) - (timeOf(a) || 0));
    },
  },
  methods: {
    openSystemPopup(payloadList) {
      this.currentNotification = payloadList;
      this.showSystemPopup = true;
    },
    markNotificationRead(notification) {
      const userId = window.localStorage.getItem("userId");
      notification.unread = false;
      Chat.markNotificationAsRead(userId, notification.firebaseId).catch(e => console.log(e));
      this.currentNotification = this.visibleNotifications;
      if (!this.currentNotification.length) {
        this.showSystemPopup = false;
      }
      this.transformConversationsToContacts();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/systemNotifications.js